<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">

           <CCol class="mt-3" v-if="!loading">
             <CRow class="mt-3">
                <CCol>
                <Clabel>Subject</Clabel>
                <CInput v-model="form.subject" class="mb-1" />
                </CCol>
              </CRow>
              <CRow class="mt-3">
                  <CCol>
                <Clabel>Content</Clabel>
                 <CInput v-model="form.content" class="mb-1" />
                 </CCol>
              </CRow>
            </CCol>
            <CCol v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CCol>

        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.id)"  variant="outline" color="info">Update</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import moment from 'moment';
import EventBus from '@/eventBus';

import ikid from '@/services/ikid'
import files from '@/services/files'

export default {
name: 'ikidnotemodal',

  data () {
    return {
      show: false,
      loading: false,
      title: 'Default Title',
      mode: '',
      form:{
        id: '',
        uuid: '',
        subject: '',
        content: '',
      },
    }
  },
  mounted(){
    
  },
  created () {
  var self = this;
    EventBus.$on('OPEN_MODAL_IKID_NOTE', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.loading = true;

        ikid.getIkidNote(params.data)
        .then(res => {
          self.form.id = res.data.id;
          self.form.content = res.data.content;
          self.form.subject = res.data.subject;
          self.loading = false;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{

        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.uuid = this.$route.query.id;
        self.form.subject = "";
        self.form.content = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
      
    },
    create(){
      this.show = false;
      ikid.createIkidNote(this.form.uuid, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
      EventBus.$emit('OPEN_MODAL_ALERT', params)
      this.show = false;
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    update(id){
      this.show = false;
      ikid.updateIkidNote(id, this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        this.show = false;
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>